import { render, staticRenderFns } from "./OsRecipientForm.vue?vue&type=template&id=7fe4c4f2&scoped=true"
import script from "./OsRecipientForm.vue?vue&type=script&lang=ts"
export * from "./OsRecipientForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe4c4f2",
  null
  
)

export default component.exports